export const TranslationType = {
  ENGLISH_ARABIC: "ENGLISH_ARABIC",
  SWEDISH_ARABIC: "SWEDISH_ARABIC",
  SWEDISH_ENGLISH: "SWEDISH_ENGLISH",
};
